import { FC, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'

import { DefaultLayout } from '../components/layout'
import routes from '../routes'

const Home = lazy(() => import('../pages/home/Home'))
const Updates = lazy(() => import('../pages/Updates'))
const Article = lazy(() => import('../pages/blog/Article'))
const Tracks = lazy(() => import('../pages/tracks/Tracks'))
const Track = lazy(() => import('../pages/tracks/Track'))
const Tag = lazy(() => import('../pages/Tag'))
const Category = lazy(() => import('../pages/blog/Blog'))
const Riders = lazy(() => import('../pages/riders/Riders'))
const Rider = lazy(() => import('../pages/riders/Rider'))
const Calendar = lazy(() => import('../pages/calendar/Calendar'))
const About = lazy(() => import('../pages/about/About'))
const NotFound = lazy(() => import('../pages/NotFound'))
const Standings = lazy(() => import('../pages/standings/Standings'))
const Results = lazy(() => import('../pages/results/Results'))

const Routing: FC = () => (
  <BrowserRouter>
    <Routes>
      <Route Component={DefaultLayout}>
        <Route path={routes.home} Component={Home} />
        <Route path={routes.updates} Component={Updates} />
        <Route path={routes.tracks} Component={Tracks} />
        <Route path={routes.tag} Component={Tag} />
        <Route path={routes.track} Component={Track} />
        <Route path={routes.article} Component={Article} />
        <Route path={routes.standings} Component={Standings} />
        <Route path={routes.standing} Component={Standings} />
        <Route path={routes.blog} Component={Category} />
        <Route path={routes.about} Component={About} />
        <Route path={routes.calendar} Component={Calendar} />
        <Route path={routes.calendars} Component={Calendar} />
        <Route path={routes.riders} Component={Riders} />
        <Route path={routes.rider} Component={Rider} />
        <Route path={routes.results} Component={Results} />
        <Route path={routes.result} Component={Results} />
        <Route path={routes.wildcard} Component={NotFound} />
      </Route>
    </Routes>
  </BrowserRouter>
)

export { Routing }
